// @flow

import md5 from 'md5';
import {Http} from './http';
import {providerUrl as _providerUrl, usersProviderV2 as _usersProviderV2} from './config';
import {Logger} from './logger';

const LIVE_EMBED_LENGTH = 8;
const VOD_EMBED_LENGTH = 10;

/**
 * Resuelve con qué versión del proveedor de JSON hay que servir el player.
 *
 * La plataforma no viaja en la url, así que se pide primero el JSON v1 para conocer el usuario:
 * si está migrado se sirve con la v2 y, si no, se devuelve la respuesta ya descargada para que
 * jsonProvider la reaproveche y no se pague una petición de más.
 *
 * @param {any} config configuración de entrada del player
 * @param {string} providerUrl host de los JSON v1
 * @returns {Promise<{version: number, playerData: any}>} versión a usar y datos v1 ya descargados
 */
export async function resolveProviderVersion(config: any, providerUrl?: string): Promise<any> {
  const logger = new Logger('providerVersion');
  const forced = parseInt(config.providerVersion);
  if (forced === 1 || forced === 2) return {version: forced, playerData: null};

  const embed = config.embed;
  // Una url sólo con el guid del vod es de la v2: sin embedkey no hay forma de preguntarle a la v1.
  if ((embed === undefined || embed === null || !embed.length) && config.id) return {version: 2, playerData: null};

  const local_providerUrl = providerUrl !== undefined && providerUrl !== null ? providerUrl : _providerUrl;
  const users = (config.usersProviderV2 !== undefined && config.usersProviderV2 ? config.usersProviderV2 : _usersProviderV2).map(u =>
    String(u).toLowerCase()
  );

  let playerData = null;
  try {
    if (embed.length === LIVE_EMBED_LENGTH) {
      playerData = await Http.execute(`${local_providerUrl}/definition/players/${md5('definition-' + embed)}.json`, null, 'GET');
    } else if (embed.length === VOD_EMBED_LENGTH) {
      playerData = await Http.execute(`${local_providerUrl}/definition/vod/players/${md5('definition-config-player-' + embed)}.json`, null, 'GET');
    } else {
      return {version: 2, playerData: null};
    }
  } catch (e) {
    // Un player creado sólo en la v2 no tiene json v1
    logger.debug('v1 json not found, using v2', e);
    return {version: 2, playerData: null};
  }

  const user = playerData !== undefined && playerData && playerData.user ? String(playerData.user).toLowerCase() : null;
  if (user && users.indexOf(user) > -1) return {version: 2, playerData: null};
  return {version: 1, playerData: playerData};
}
